module.exports = __webpack_public_path__ + "img/fb.f090eab2.png";